// Uses REACT_APP_API_URL env variable in production, falls back to localhost for development
// Note: BaseUrl is the server root (no /api/v1 suffix) — callers append their own paths
export const BaseUrl = process.env.REACT_APP_API_URL
  ? process.env.REACT_APP_API_URL.replace(/\/api\/v1\/?$/, '')
  : 'http://localhost:5000';